import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FeatureFlagStore } from '../feature-flags.store';
@Component({
    selector: 'app-flag-group',
    templateUrl: './flag-group.component.html',
    styleUrls: ['./flag-group.component.css']
})
export class FlagGroupComponent {
    @Input() groupName!: string;
    @Input() isFullAdmin: boolean = false;
    @Input() flagKeys: string[] = [];
    @Input() groupDescription?: string;
    @Input() flagHelpMapping: Record<string, string> = {};
    @Input() modifiedFlags: Record<string, boolean> = {};
    @Input() activeFlags: Record<string, boolean> = {};
    @Input() isToggleDisabled: boolean = false;
    @Input() isCollapsed: boolean = false;

    @Output() toggleFlag = new EventEmitter<string>();
    @Output() toggleGroup = new EventEmitter<string>();

    onToggleFlag(key: string) {
        this.toggleFlag.emit(key);
    }

    onToggleGroup() {
        this.toggleGroup.emit(this.groupName);
    }

    isFlagModified(key: string): boolean {
        return this.modifiedFlags[key];
    }

    isFlagActive(key: string): boolean {
        return this.activeFlags[key];
    }

    isFlagMissing(key: string): boolean {
        return !FeatureFlagStore.isFlagAvailable(key);
    }

    get flagCount(): number {
        return this.flagKeys.filter((key) => !this.isFlagMissing(key)).length;
    }

    get isGroupModified(): boolean {
        return this.flagKeys
            .filter((key) => !this.isFlagMissing(key))
            .some((key) => this.modifiedFlags[key]);
    }

    get isGroupEnabled(): boolean {
        return this.flagKeys
            .filter((key) => !this.isFlagMissing(key))
            .every((key) => this.activeFlags[key]);
    }

    toggleCollapsed() {
        this.isCollapsed = !this.isCollapsed;
    }
}
